import React from "react";
import { Modal, Alert, Button } from "react-bootstrap";
import { reduxForm, Field } from "redux-form";
import { SimpleField, TextAreaField } from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';
import { connect } from "react-redux";
import { news as newsType } from '../../../constants/settingTypes';
import { FileInput } from '../../common/FileInput';

const validate = (values, props) => {
    const errors = {};
    const required = type => {
        if (!values[type] || values[type].length === 0|| !values[type] || values[type].trim().length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }

    if(props.isNew && !values.Image){
        errors.Image = '*Обязательно для заполнения';
    }

    required('Title');
    required('Description');
    return errors;
}

class EditModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Image: props.isNew ? null : `api/settings/news/image/${props.initialValues.Id}?t=${new Date().getTime()}`,
        };
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit(values) {
        this.props.onSubmit(values);
    }

    render() {
        const {
            fetching,
            onClose,
            handleSubmit,
            anyTouched,
            error,
            isNew,
            pristine,
            crudError,
        } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;
        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новая новость' : 'Редактирование новость'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && (
                        <form className="form-horizontal">
                            <Field name="Title" component={SimpleField} label="Название" />
                            <Field name="Description" component={TextAreaField} label="Описание" />
                            <Field
                                name="Image"
                                component={FileInput}
                                label="Картинка"
                                accept=".png, .jpg, .jpeg"
                                onChange={(event, newValue, previousValue, name) => {
                                    const file =  newValue;
                                    if (file) {
                                        const image = URL.createObjectURL(file);
                                        this.setState({ Image: image });
                                    }
                                }}
                            />
                            {this.state.Image && <img src={this.state.Image} alt="Загруженное изображение" height="50" />}
                            {anyTouched && error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
                        </form>
                    )}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle="info">Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED && <Alert bsStyle="success">УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED && (
                        <Alert bsStyle="danger">
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                    )}
                </Modal.Body>
                {formVisible && (
                    <Modal.Footer>
                        <Button bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)} disabled={pristine}>
                            Сохранить
                        </Button>
                        <Button type="button" onClick={onClose}>
                            Отмена
                        </Button>
                    </Modal.Footer>
                )}
                {closeButtonVisible && (
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        );
    }
}

EditModal = reduxForm({
    form: 'newsEdit',
    validate,
})(EditModal);

EditModal = connect((state) => ({
    fetching: state.application.get('settings')[newsType].updateFetching,
    crudError: state.application.get('settings')[newsType].updateError,
}))(EditModal);

export default EditModal;



// WEBPACK FOOTER //
// ./src/components/settings/news/EditModal.jsx